import React, {useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { endCall, startCall, hideEndCallPopUp, setCallDirection, setUserData, setPhoneNumberForCreateLead, setCallerTreatment, setLastTreatment, setTypeEndOfCall, setMessageEndOfCall, setLoadTreatmentToQueue } from '../app-context/caller';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import './calls.css';
import { CustomerCardModel } from '../models/CustomerCardModel';
import { LeadFilterModel } from '../models/superbit-api-models';
import { Spin } from 'antd';
import SignalCallerServiceModel from '../models/SignalCallerServiceModel';
import { useNavigate } from 'react-router-dom';
import { setIdForLeadPopup } from '../app-context/policyProduction';
import { LeadsModel } from '../models/LeadsModel';
import SuccessPopUp from './_SuccessPopUp';
import ListOfCalls from './ListOfCalls';
import { RootState } from '../app-context/store';
import moment from 'moment-timezone';
import SignalRServiceModel from '../models/SignalRServiceModel';

type Props = {
    onChange?: Function;
};

const CallStatus = (props: Props) => {

    const leadsModel: LeadsModel = new LeadsModel();
    const customerCardModel: CustomerCardModel = new CustomerCardModel();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Get call status from Redux store
    const callStarted = useSelector((state: any) => state.call.value);

    // Get user data from Redux store for incoming call details
    const userName = useSelector((state: any) => state.call.userName);
    const userPhone = useSelector((state: any) => state.call.userPhone);
    const callDirection = useSelector((state: any) => state.call.callDirection);

    // Get the last treatment from the Redux store
    const lastTreatment = useSelector((state: RootState) => state.call.lastTreatment);
    const typeEndOfCall = useSelector((state: RootState) => state.call.typeEndOfCall);
    const messageEndOfCall = useSelector((state: RootState) => state.call.messageEndOfCall);

    const [showEndCall, setShowEndCall] = useState<boolean>(false);

    // State for end call customer details
    const [endCallCustomerIds, setEndCallCustomerIds] = useState<string[]>([]);
    const [selectedCustomer, setSelectedCustomer] = useState<any>({
        name: '',
        id: ''
    });
    const [endCallCustomers, setEndCallCustomers] = useState<any[]>([]);

    // State for end call lead details
    const [endCallLeadIds, setEndCallLeadIds] = useState<string[]>([]);
    const [selectedLead, setSelectedLead] = useState<any>({
        name: '',
        id: ''
    });
    const [endCallLeads, setEndCallLeads] = useState<any[]>([]);
    const [redirectCall, setRedirectCall] = useState<string>("");

    const [message, setMessage] = useState<string>('');
    const [typeOfAnswer, setTypeOfAnswer] = useState<number>(0);
    const [minimized, setMinimized] = useState<boolean>(true);

    // State for comment 
    const [displayComment, setDisplayComment] = useState<boolean>(false);
    const [commentMessage, setCommentMessage] = useState<string>('');

    // State for treatment
    const [treatment, setTreatment] = useState<any>(null);
    const [successPopUp, setSuccessPopUp] = useState<boolean>(false);

    // State for loading indicators
    const [loadingLead, setLoadingLead] = useState<boolean>(true);
    const [loadingCustomer, setLoadingCustomer] = useState<boolean>(true);

    const [position, setPosition] = useState({ x: 500, y: 200 }); // Initial position of the popup
    const [isDragging, setIsDragging] = useState(false);
    const [offset, setOffset] = useState({ x: 0, y: 0 });

    const [messageCallingEnd, setMessageCallingEnd] = useState<string>('');
    const [leadIdAndNameForNavigate, setLeadIdAndNameForNavigate] = useState<any>({ type: '', name: '', id: '' });
    const [idAndNameForNavigate, setIdAndNameForNavigate] = useState<any>({ type: '', name: '', id: '' });

    const [userHasLogged, setUserHasLogged] = useState<boolean>(false);

    useEffect(() => {
      const loggerUser = localStorage.getItem('loggedUser');
      if(!loggerUser) {
        setUserHasLogged(false);
        navigate('/Login');
      } else {
        setUserHasLogged(true);
      }
    }, [])
    

    const closeOnGoingPopUp = () => {
        dispatch(endCall());
        setMinimized(true);
    }

    const closeEndCallPopUp = () => {
        setCommentMessage('');
        setSelectedCustomer({ name: '', id: '' });
        setSelectedLead({ name: '', id: '' });
        setTreatment(null);
        setTypeOfAnswer(0);
        setDisplayComment(false);

        SignalRServiceModel.setLastTreatment('');

        dispatch(hideEndCallPopUp())
        setShowEndCall(false);
        setMessageCallingEnd('');

        dispatch(setLastTreatment(null));

        setEndCallCustomers([]);
        setEndCallLeads([]);

    }

    const getCustomersByIds = async () => {
        setLoadingCustomer(true);
        setEndCallCustomers([]);
        if (endCallCustomerIds && endCallCustomerIds.length > 0) {
            try {
                const customers = await Promise.all(
                    [...endCallCustomerIds].map(async (customerId) => {
                        const customerCardData = await customerCardModel.getCustomerCardDetails(customerId);

                        if (customerCardData) {
                            return {
                                label: customerCardData.personalData.customerData.fullName + "/" + customerCardData.personalData.customerData.identifier,
                                value: customerId
                            };
                        }
                        return null;
                    })
                );
                const filteredCustomers = customers.filter(Boolean); // remove nulls
                filteredCustomers.unshift({ label: 'בחר לקוח', value: '' }); // Add a default option
                setEndCallCustomers(filteredCustomers);
            } catch (error) {
                console.error('Error in getCustomersByIds:', error);
            }
        }
        setLoadingCustomer(false);
    }

    const getLeadsByIds = async () => {
        setLoadingLead(true);
        setEndCallLeads([]);
        if (endCallLeadIds && endCallLeadIds.length > 0) {
            try {
                const leads = await Promise.all(
                    endCallLeadIds.map(async (leadId) => {
                        const filter = new LeadFilterModel();
                        filter.page = 1;
                        filter.LeadId = leadId;
                        const leadData = await leadsModel.filter(filter);
                        if (leadData) {
                            return {
                                label: leadData.leads[0].lead.firstName + ' ' + leadData.leads[0].lead.lastName,
                                value: leadId
                            };
                        }
                        return null;
                    })
                );
                const filteredLeads = leads.filter(Boolean); // remove nulls
                filteredLeads.unshift({ label: 'בחר ליד', value: '' }); // Add a default option
                setEndCallLeads(filteredLeads);
            } catch (error) {
                console.error('Error in getLeadsByIds:', error);
            }
        }
        setLoadingLead(false);
    }


    const onSelectCustomer = (value: string) => {
        if (endCallCustomers) {
            const selectedOption = endCallCustomers.find((opt: any) => opt.value === value);
            if (selectedOption && selectedOption.label) {
                setSelectedCustomer(selectedOption.label.toString());
                setSelectedCustomer({
                    name: selectedOption.label.toString(),
                    id: selectedOption.value
                })
            }
        }
    };

    const onSelectLead = (value: string) => {
        if (endCallLeads) {
            const selectedOption = endCallLeads.find((opt: any) => opt.value === value);
            if (selectedOption && selectedOption.label) {
                setSelectedLead(selectedOption.label.toString());
                setSelectedLead({
                    name: selectedOption.label.toString(),
                    id: selectedOption.value
                })
            }
        }
    };

    useEffect(() => {

        setRedirectCall(callDirection);
    }, [callDirection]);


    useEffect(() => {

        getCustomersByIds();
    }, [endCallCustomerIds])

    useEffect(() => {
        getLeadsByIds();

    }, [endCallLeadIds])


    const incomingCallDetailsQueue = async (queueTreatment: any, type: any, _messageType: string) => {
        dispatch(setLastTreatment(queueTreatment));
        SignalRServiceModel.setLastTreatment(queueTreatment.Id);


        const newTreatment = await customerCardModel.treatmentsGetById(queueTreatment.Id);

        setTypeOfAnswer(Number(type));
        setTreatment(newTreatment);
        if (type == 1) {
            if (queueTreatment && queueTreatment.CustomersIds && queueTreatment.CustomersIds.length == 1) {
                setMessage("נוספה שיחה חדשה לטיפול שוטף לקוח");
            } else if (queueTreatment && queueTreatment.LeadsIds && queueTreatment.LeadsIds.length == 1) {
                setMessage("נוספה שיחה חדשה לטיפול שוטף ליד");
            }
            // setMessage(_messageType);
        } else if (type == 2) {
            if (queueTreatment && queueTreatment.CustomersIds) {
                setEndCallCustomerIds(queueTreatment.CustomersIds);
            }
            // check if the treatment has leads ids
            if (queueTreatment && queueTreatment.LeadsIds) {
                setEndCallLeadIds(queueTreatment.LeadsIds);
            }
            // set all customers ids for get info about them

        } else if (type == 3) {
            const userLogged = localStorage.getItem('loggedUser');
            if (userLogged) {
                const parsedUser = JSON.parse(userLogged);
                if (parsedUser && parsedUser.id) {
                    if (parsedUser.extensions == queueTreatment.From) {
                        dispatch(setPhoneNumberForCreateLead({ phoneNumber: queueTreatment.To }));
                    } else if (parsedUser.extensions == queueTreatment.To) {
                        dispatch(setPhoneNumberForCreateLead({ phoneNumber: queueTreatment.From }));
                    }
                }
            }
            dispatch(setCallerTreatment({ "treatment": newTreatment }));
        }
        const from = queueTreatment.From ? queueTreatment.From : '';
        const to = queueTreatment.To ? queueTreatment.To : '';
        const loggerUser = localStorage.getItem('loggedUser');
        if (loggerUser) {
            const parsedUser = JSON.parse(loggerUser);
            if (parsedUser && parsedUser.extensions) {
                let titleMeesage = '';
                if (parsedUser.extensions == from) {
                    titleMeesage = `  שיחה יוצאת מ${to}`;
                } else if (parsedUser.extensions == to) {
                    titleMeesage = `  שיחה נכנסת מ${from}`;
                }
                setMessageCallingEnd(titleMeesage);
            }
        }
        setShowEndCall(true);
        // dispatch(endCall());
        setMinimized(true);
    }

    const onIncomingCallDetails = (lead: any, customer: any, phone: any) => {
        if(phone && phone.toString().length < 5) {
            return; // Ignore if phone number is too short
        }
        console.log('onIncomingCallDetails', lead, customer);
        console.log('onIncomingCallDetails-callDirection', callDirection)
        dispatch(startCall());
        if (callDirection == 'שיחה יוצאת') {
            dispatch(setCallDirection({ direction: '' }));
            setRedirectCall('שיחה יוצאת');
        } else {
            dispatch(setCallDirection({ direction: '' }));
            setRedirectCall('שיחה נכנסת');

            // Check outgoing call details
            dispatch(setUserData({
                userName: lead && lead.FullName ? lead.FullName : customer && customer.FullName ? customer.FullName : userName,
                userPhone: isNaN(Number(phone)) ? userPhone : phone ? phone : "לא זוהה"
            }));
        }

        if (lead && lead.Id) {
            // If lead exists but customer does not, set phone number for creating a lead
            setLeadIdAndNameForNavigate({ type: 'lead', name: lead.FullName, id: lead.Id })
        }
        if (customer && customer.Id) {
            // If customer exists but lead does not, set phone number for creating a lead
            setIdAndNameForNavigate({ type: 'customer', name: customer.FullName, id: customer.Id });
        }
    };


    const onEndCallDetails = async (jsonObject: any, _messageType: string) => {

        // check if jsonObject.treatment.From and jsonObject.treatment.To smaller than 5 character then return
        if (jsonObject.treatment.From && jsonObject.treatment.From.toString().length < 5 &&
            jsonObject.treatment.To && jsonObject.treatment.To.toString().length < 5) {
            return; // Ignore if From and To are too short
        }
       
        //reset the call incoming data
        dispatch(setUserData({ userName: "", userPhone: "" }));
        dispatch(endCall());

        console.log('onEndCallDetails-useCallback:', lastTreatment, typeOfAnswer, treatment);

        if (SignalRServiceModel.lastTreatment && SignalRServiceModel.lastTreatment != '') {

            // check if is same treatment
            if (lastTreatment && jsonObject.treatment && lastTreatment.Id == jsonObject.treatment.Id) {
                return null;
            } else {
                const treatmentQueue = localStorage.getItem('treatmentQueue');
                let treatmentToStore = { ...jsonObject.treatment };
                treatmentToStore["TypeEndOfCall"] = jsonObject.Type;
                treatmentToStore["MessageEndOfCall"] = _messageType;
                treatmentToStore["CreatedDate"] = moment(new Date()).format('YYYY-MM-DD HH:mm');
                if (treatmentQueue) {
                    const parsedQueue = JSON.parse(treatmentQueue);
                    if (parsedQueue && parsedQueue.length > 0) {
                        // add the new treatment to the queue
                        const updatedQueue = [...parsedQueue, treatmentToStore];
                        console.log('Updated treatment queue if:', updatedQueue);
                        // save the updated queue back to localStorage
                        localStorage.setItem('treatmentQueue', JSON.stringify(updatedQueue));
                    }
                } else {
                    console.log('Updated treatment queue else:', [treatmentToStore]);
                    // if no queue exists, create a new one with the current treatment
                    localStorage.setItem('treatmentQueue', JSON.stringify([treatmentToStore]));
                }
                dispatch(setLoadTreatmentToQueue({ load: true }));
                return null;
            }
        }


        SignalRServiceModel.setLastTreatment(jsonObject.treatment.Id);
        dispatch(setLastTreatment(jsonObject.treatment));        
        dispatch(setTypeEndOfCall({ "type": jsonObject.Type }));
        dispatch(setMessageEndOfCall({ "message": _messageType }));

        const newTreatment = await customerCardModel.treatmentsGetById(jsonObject.treatment.Id);

        setTypeOfAnswer(Number(jsonObject.Type));
        setTreatment(newTreatment);

        setMessage(_messageType);
        if (jsonObject.Type == 1) {
            if (jsonObject.treatment && jsonObject.treatment.CustomersIds && jsonObject.treatment.CustomersIds.length == 1) {
                setMessage("נוספה שיחה חדשה לטיפול שוטף לקוח");
            } else if (jsonObject.treatment && jsonObject.treatment.LeadsIds && jsonObject.treatment.LeadsIds.length == 1) {
                setMessage("נוספה שיחה חדשה לטיפול שוטף ליד");
            }
        } else if (jsonObject.Type == 2) {

            if (jsonObject.treatment && jsonObject.treatment.CustomersIds) {
                setEndCallCustomerIds(jsonObject.treatment.CustomersIds);
            }
            // check if the treatment has leads ids
            if (jsonObject.treatment && jsonObject.treatment.LeadsIds) {
                setEndCallLeadIds(jsonObject.treatment.LeadsIds);
            }
            // set all customers ids for get info about them

        } else if (jsonObject.Type == 3) {
            const userLogged = localStorage.getItem('loggedUser');
            if (userLogged) {
                const parsedUser = JSON.parse(userLogged);
                if (parsedUser && parsedUser.id) {
                    if (parsedUser.extensions == jsonObject.treatment.From) {
                        dispatch(setPhoneNumberForCreateLead({ phoneNumber: jsonObject.treatment.To }));
                    } else if (parsedUser.extensions == jsonObject.treatment.To) {
                        dispatch(setPhoneNumberForCreateLead({ phoneNumber: jsonObject.treatment.From }));
                    }
                }
            }
            dispatch(setCallerTreatment({ "treatment": newTreatment }));
        }

        const from = jsonObject.treatment.From ? jsonObject.treatment.From : '';
        const to = jsonObject.treatment.To ? jsonObject.treatment.To : '';
        const loggerUser = localStorage.getItem('loggedUser');
        if (loggerUser) {
            const parsedUser = JSON.parse(loggerUser);
            if (parsedUser && parsedUser.extensions) {
                let titleMeesage = '';
                if (parsedUser.extensions == from) {
                    titleMeesage = `שיחה יוצאת מ ${to}`;
                } else if (parsedUser.extensions == to) {
                    titleMeesage = `שיחה נכנסת מ ${from}`;
                }
                setMessageCallingEnd(titleMeesage);
            }
        }

        setShowEndCall(true);
        setMinimized(true);
    }


    const createLeadAfterCall = () => {
        setShowEndCall(false);
        let newLead = "0";
        dispatch(setIdForLeadPopup(newLead))
        navigate('/Leads');
    }

    const redirectToLead = () => {
        console.log('idAndNameForNavigate', idAndNameForNavigate)
        if (leadIdAndNameForNavigate.type == 'lead') {
            // Redirect to lead details
            const lastLeadsFilter = localStorage.getItem('lastLeadsFilter');
            if (lastLeadsFilter) {
                const lastFilter = JSON.parse(lastLeadsFilter);
                console.log('lastLeadsFilter', lastFilter)
                lastFilter.searchText = userPhone;
                localStorage.setItem('lastLeadsFilter', JSON.stringify(lastFilter));
                navigate('/leads/');
            }
        }
    }

    const redirectToClient = () => {

        if (idAndNameForNavigate.type == 'customer') {
            // Redirect to customer details
            const newFilter = {
                filterSearch: {
                    property: "Phones",
                    searchText: userPhone
                },
                page: 1
            }
            localStorage.setItem('lastClientsFilter', JSON.stringify(newFilter));
            navigate(`/Clients/`);
        }
    }


    const onSave = () => {
        // Handle saving the end call details 
        // save inside treatment
        const treatmentData = { ...treatment };

        if (treatmentData) {
            if (commentMessage && commentMessage.trim() !== '') {
                treatmentData.emailBody = commentMessage;
            }
            if (selectedCustomer.id && selectedCustomer.id !== '') {
                treatmentData.customerId = selectedCustomer.id;
            } else if (selectedLead.id && selectedLead.id !== '') {
                treatmentData.leadRelatedId = selectedLead.id;
            }

            customerCardModel.treatmentsUpsertTreatment(treatmentData).then((res: any) => {
                console.log('saveTreatment-res', res);
                if (res) {
                    setCommentMessage('');
                    setSelectedCustomer({ name: '', id: '' });
                    setSelectedLead({ name: '', id: '' });
                    setSuccessPopUp(true);
                    setTypeOfAnswer(0);
                    // Optionally, you can show a success message or perform other actions
                    console.log('Treatment saved successfully');
                    setShowEndCall(false);
                    dispatch(hideEndCallPopUp());
                    setTreatment(null);
                    setDisplayComment(false);
                    setEndCallCustomers([]);
                    setEndCallLeads([]);

                    // delete fro localstorage in queueTreatment
                    const treatmentQueue = localStorage.getItem('treatmentQueue');
                    if (treatmentQueue) {
                        const parsedQueue = JSON.parse(treatmentQueue);
                        const updatedQueue = parsedQueue.filter((t: any) => t.Id !== treatmentData.id);
                        localStorage.setItem('treatmentQueue', JSON.stringify(updatedQueue));
                        dispatch(setLoadTreatmentToQueue({ load: true }));
                    }
                } else {
                    console.error('Failed to save treatment:', res);
                }
            }).catch((error: any) => {
                console.error('Error saving treatment:', error);
            });
        }
    }

    const closeAndSaveForLatter = () => {
        // Handle saving the end call details for later
        const treatmentQueue = localStorage.getItem('treatmentQueue');
        let treatmentToStore = { ...lastTreatment };
        treatmentToStore["TypeEndOfCall"] = typeEndOfCall;
        treatmentToStore["MessageEndOfCall"] = messageEndOfCall;
        treatmentToStore["CreatedDate"] = moment(new Date()).format('YYYY-MM-DD HH:mm'); // Add created date
        if (treatmentQueue && treatmentQueue.length > 0 && treatmentQueue != '[]') {
            console.log('closeAndSaveForLatter-treatmentQueue', treatmentQueue)
            const parsedQueue = JSON.parse(treatmentQueue);
            if (parsedQueue && parsedQueue.length > 0) {
                const found = parsedQueue.find((t: any) => t.Id === treatmentToStore.Id);
                if (found) {
                    closeEndCallPopUp();
                    return;
                }
                const updatedQueue = [...parsedQueue, treatmentToStore];
                // save the updated queue back to localStorage
                localStorage.setItem('treatmentQueue', JSON.stringify(updatedQueue));
            }
        } else {
            console.log('closeAndSaveForLatter-treatmentQueue-empty', treatmentQueue)
            // if no queue exists, create a new one with the current treatment
            localStorage.setItem('treatmentQueue', JSON.stringify([treatmentToStore]));
        }
        console.log('closeAndSaveForLatter-treatmentToStore-end', treatmentToStore)

        dispatch(setLoadTreatmentToQueue({ load: true }));
        closeEndCallPopUp();
    }

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {

        // this.setState({ isDragging: true, offset: { x: e.clientX - this.state.position.x, y: e.clientY - this.state.position.y } });
        setIsDragging(true);
        setOffset({ x: e.clientX - position.x, y: e.clientY - position.y });
    };

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        if (isDragging) {
            setPosition({
                x: e.clientX - offset.x,
                y: e.clientY - offset.y
            });
        }
    };

    const handleMouseUp = (): void => {
        setIsDragging(false);
    };


    return (
        <>
            {
                /* Render the Successful popup if call is ongoing and minimized */
                successPopUp &&
                <SuccessPopUp
                    onClose={() => setSuccessPopUp(false)}
                    message="יצירה טיפול שוטף מסוג שיחה בוצעה בהצלחה"
                />
            }

            {userHasLogged && <SignalCallerServiceModel
                onIncomingCallDetails={onIncomingCallDetails}
                onEndCallDetails={onEndCallDetails}
            />}

            <ListOfCalls incomingCallDetailsQueue={incomingCallDetailsQueue} />

            {callStarted ? (
                <div className='call-info-minimized'>
                    <div className='header-of-calling'>
                        <div onClick={() => closeOnGoingPopUp()}>X</div>
                        <div>
                            {redirectCall}
                        </div>
                    </div>

                    <div className="call-info-content">

                        <div>
                            {userName} / {userPhone}
                        </div>
                        <div className='call-icon-popup'></div>
                    </div>
                    <div className="call-to-client">
                        {idAndNameForNavigate.type == 'customer' && idAndNameForNavigate.id && idAndNameForNavigate.name ? (
                            <button onClick={() => redirectToClient()} className="call-to-client-btn">
                                מעבר לתיק הלקוח
                            </button>
                        ) : (<></>)}

                        {leadIdAndNameForNavigate.type == 'lead' && leadIdAndNameForNavigate.id && leadIdAndNameForNavigate.name ? (
                            <button onClick={() => redirectToLead()} className="call-to-client-btn">
                                מעבר לליד
                            </button>
                        ) : (<></>)}
                    </div>
                </div>) : (<></>)
            }
            {showEndCall ? (
                <div className="popup-call-info"
                    style={{ position: 'absolute', top: position.y, left: position.x, height: (typeOfAnswer == 1 || typeOfAnswer == 3) ? '45%' : '55%' }}
                >
                    <div className="call-popup-header"
                        style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
                        onMouseDown={handleMouseDown}
                        onMouseMove={handleMouseMove}
                        onMouseUp={handleMouseUp}
                        onMouseLeave={handleMouseUp}>
                        <div className="call-close-icon pointer" onClick={() => closeEndCallPopUp()}></div>
                        <div className="popup-title">

                        </div>
                    </div>
                    <div className="popup-call-body">
                        <div style={{ paddingBottom: '7px', textAlign: 'center' }}>
                            {messageCallingEnd}
                        </div>
                        <div className='header-call-info'>
                            <div style={{ paddingLeft: '10px' }}>
                                {"שיחה הסתיימה -"}
                            </div>
                            <div className='flex-justify-center caller-text'>
                                <FontAwesomeIcon icon={faPhoneAlt} />
                            </div>
                        </div>


                        <div>
                            <div className='flex-justify-center caller-text'>
                                {message}
                            </div>
                        </div>

                        {typeOfAnswer == 3 ?
                            <div className='flex-justify-center'>
                                <button type="button" onClick={createLeadAfterCall} className='new-lead-call' style={{ marginLeft: 10 }}>
                                    <div className="icon add hide"></div>הוסף ליד חדש +
                                </button>

                            </div> : <></>}

                        <div>
                            {endCallCustomers && endCallCustomers.length > 0 && typeOfAnswer == 2 && !loadingLead && !loadingCustomer
                                ? (

                                    <div>
                                        <div className='caller-recipient-name'>
                                             חפש לקוח קיים
                                        </div>
                                        {/* <Select
                                                style={{ width: '95%', margin: '0px 10px' }}
                                                value={selectedCustomer.name}
                                                options={endCallCustomers}
                                                onSelect={onSelectCustomer}
                                                allowClear={true}
                                                placeholder="בחר לקוח"
                                                disabled={selectedLead.id && selectedLead.id !== ''}
                                                onClear={() => setSelectedCustomer({ label: 'בחר לקוח', value: '' })}
                                            /> */}
                                        <select className='select-lead-customer'
                                            style={{ width: '95%', margin: '0px 10px', backgroundColor: '#485869', color: 'white' }}
                                            value={selectedCustomer.id}
                                            onChange={(e: any) => onSelectCustomer(e.target.value)}
                                            disabled={selectedLead.id && selectedLead.id !== ''}
                                        >
                                            {endCallCustomers.map((customer: any) => (
                                                <option key={customer.value} value={customer.value}>
                                                    {customer.label}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                ) : (<></>)}

                            {endCallLeads && endCallLeads.length > 0 && typeOfAnswer == 2 && !loadingLead && !loadingCustomer
                                ? (
                                    <div>
                                        <div className='caller-recipient-name'>
                                            חפש ליד קיים 
                                        </div>
                                        {/* <Select
                                                style={{ width: '95%', margin: '0px 10px' }}
                                                value={selectedLead.name}
                                                options={endCallLeads}
                                                onSelect={onSelectLead}
                                                allowClear={true}
                                                placeholder="בחר ליד"
                                                disabled={selectedCustomer.id && selectedCustomer.id !== ''}
                                                onClear={() => setSelectedLead({ label: 'בחר ליד', value: '' })}
                                            /> */}
                                        <select className='select-lead-customer'
                                            style={{ width: '95%', margin: '0px 10px', backgroundColor: '#485869', color: 'white' }}
                                            value={selectedLead.id}
                                            onChange={(e: any) => onSelectLead(e.target.value)}
                                            disabled={selectedCustomer.id && selectedCustomer.id !== ''}
                                        >
                                            {endCallLeads.map((lead: any) => (
                                                <option key={lead.value} value={lead.value}>
                                                    {lead.label}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                ) : (<></>)}

                        </div>

                        {loadingLead || loadingCustomer ? (
                            <div style={{ textAlign: 'center' }}><Spin size="large" />
                            </div>

                        ) : (<></>)}

                        {typeOfAnswer < 3 &&
                            <div className='comment-call-section'>
                                <p className='comment-call-text'>
                                    מומלץ להוסיף סיכום -
                                    <button style={{
                                        border: 'none', backgroundColor: 'transparent', color: '#007bff', cursor: 'pointer', fontSize: '20px', paddingRight: '10px'
                                    }} onClick={() => setDisplayComment(true)}>לטיפול שוטף</button>

                                </p>

                                {
                                    displayComment ? (
                                        <textarea
                                            rows={5}
                                            placeholder="הוסף סיכום לשיחה"
                                            value={commentMessage}
                                            onChange={(e) => setCommentMessage(e.target.value)}
                                            className='comment-textarea'
                                        />
                                    ) : (<></>)
                                }
                            </div>
                        }

                        <div className='call-btn-group'>
                            {(selectedCustomer.id || selectedLead.id || commentMessage.length > 0) && typeOfAnswer < 3 &&
                                <button style={{ marginLeft: 10 }} type="button" onClick={onSave} className="button blue _has-icon flex-centered flex-justify-center">שמירה</button>
                            }

                            <button className='call-care-latter-btn' type="button" onClick={() => closeAndSaveForLatter()}>
                                לטיפול בהמשך
                            </button>

                        </div>

                    </div>
                </div >
            ) : (<></>)}
        </>
    )
}


export default CallStatus;
